import Laptop from "./assets/laptop.svg";
import Smartphone from "./assets/smartphone.svg";
import TV from "./assets/tv.svg";
import Tablet from "./assets/tablet.svg";
import Streamer from "./assets/streamer.svg";


import StreamerAnimationData from "./assets/streamer.json";
import TabletAnimationData from "./assets/tablet.json";
import SmartphoneAnimationData from "./assets/smartphone.json";
import ComputerAnimationData from "./assets/computer.json";
import TVAnimationData from "./assets/tv.json";

export const listOfDevices = [

  {
    img: Smartphone,
    animationSize: { width: 100, height: 75 },
    animationData: SmartphoneAnimationData,
    name: "Smartphone",
    translationKey: "landing.block-devices.types.smartphone",
  },
  {
    img: Tablet,
    animationSize: { width: 100, height: 75 },
    animationData: TabletAnimationData,
    name: "Tablet",
    translationKey: "landing.block-devices.types.tablet",
  },
  {
    img: TV,
    animationSize: { width: 100, height: 75 },
    animationData: TVAnimationData,
    name: "TV",
    translationKey: "landing.block-devices.types.desktop",
  },
  {
    img: Laptop,
    animationSize: { width: 100, height: 75 },
    animationData: ComputerAnimationData,
    name: "Laptop",
    translationKey: "landing.block-devices.types.laptop",
  },
  {
    img: Streamer,
    animationSize: { width: 100, height: 75 },
    animationData: StreamerAnimationData,
    name: "Streamer",
    translationKey: "landing.block-devices.types.streamer",
  },
];



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-devices/config.js